import { format } from 'date-fns';
import generatedBuildInfo from 'src/utilities/buildInfo/generatedBuildInfo.json';

export const buildVersion = `#${generatedBuildInfo.gitCommitHash}-${format(
  new Date(generatedBuildInfo.time),
  'yyyyMMddHHmmss',
)}`;
